import { createContext } from 'react'
import { type User } from '../../utils/User'

export interface SubscriptionVerificationContextType {
  error: string | undefined
  setError: (error: string | undefined) => void
  isTrialLoading: boolean
  manageTrial: (currentUser: User, currentRevenueCatUserId: string) => Promise<any>
  setDialogOpen: (open: boolean) => void
  dialogOpen: boolean
  trialEndDate: string | undefined
  isSubscribed: boolean
  isGuest: boolean
  isTrialRunning: string | undefined
  stripeCustomerId: string | undefined
  stripeSubscriptionId: string | undefined
  trackTrialBannerClicked: () => void
}

export const SubscriptionVerificationContext = createContext<SubscriptionVerificationContextType | undefined>(undefined)
